import React, { useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import AddressSearch from 'react-loqate';
import 'react-loqate/dist/react-loqate.cjs.development.css';
import { useDispatch, useSelector } from 'react-redux';
import { actions, getQuote } from '../../../features/quote/QuoteSlice';
import Tooltip from '../Tooltip';

function AddressInputContainer(props: any): JSX.Element {
  const { value, onChange } = props;
  const { getValues, setValue, trigger } = useFormContext();
  const { data } = useSelector(getQuote);
  return (
    <input
      placeholder="Start typing your address or postcode"
      autoComplete="chrome-off"
      {...props}
      onChange={(e: any) => {
        onChange(e);
        const values = getValues();
        values.quote.forEach((quote: any, index: number) => {
          if (quote.formId === 'frm_personal_postcode'
                || quote.formId === 'payment_bill_postcode') {
            setValue(`quote.${index}.value`, e.target.value);
            trigger(`quote.${index}.value`);
          }
        });
      }}
    />

  );
}

function AddressSearchInput(props: any) {
  const { getValues, setValue, trigger } = useFormContext();
  const dispatch = useDispatch();
  const {
    field, value, error, inputRef,
  } = props;
  const [useLookup, setUseLookup] = useState(false);
  const {
    data,
  } = useSelector(getQuote);
  useEffect(() => {
    setValue(inputRef.name, data[field.formId] || field.value || '');
  }, []);

  return (
    <div className={`mb-4 form-card p-4 ${error ? 'error' : ''}`}>
      <label htmlFor={field.id} className="form-label my-2">
        {field.label}
        {field.required
                && <span className="ms-2 d-inline-block asterix">*</span>}
      </label>
      {useLookup
        ? (
          <AddressSearch
            locale="en_GB"
            apiKey="hd22-mz37-wu24-wb92"
            className="form-control my-2"
            countries={['GB']}
            components={{ Input: AddressInputContainer }}
            classes={{ list: 'styled-list' }}
            onSelect={(address) => {
              // Update values
              const values = getValues();
              values.quote.forEach((quote: any, index: number) => {
                if (quote.formId === 'frm_personal_address1'
                || quote.formId === 'payment_bill_address1') {
                  setValue(`quote.${index}.value`, address.Line1);
                  trigger(`quote.${index}.value`);
                }
                if (quote.formId === 'frm_personal_address2'
                || quote.formId === 'payment_bill_address2') {
                  setValue(`quote.${index}.value`, address.Line2);
                  trigger(`quote.${index}.value`);
                }
                if (quote.formId === 'frm_personal_address3'
                || quote.formId === 'payment_bill_address3') {
                  setValue(`quote.${index}.value`, address.City);
                  trigger(`quote.${index}.value`);
                }
                if (quote.formId === 'frm_personal_address4'
                || quote.formId === 'payment_bill_address4') {
                  setValue(`quote.${index}.value`, address.Province);
                  trigger(`quote.${index}.value`);
                }
                if (quote.formId === 'frm_personal_country_code'
                || quote.formId === 'payment_bill_country') {
                  setValue(`quote.${index}.value`, address.CountryIso2);
                  trigger(`quote.${index}.value`);
                }
                if (quote.formId === 'frm_personal_postcode'
                || quote.formId === 'payment_bill_postcode') {
                  setValue(`quote.${index}.value`, address.PostalCode);
                  trigger(`quote.${index}.value`);
                }
              });
              setUseLookup(false);
              dispatch(actions.updateQuote(getValues()));
            }}
            inline
            debounce={500}
          />
        )
        : <input {...inputRef} readOnly={field.disabled === 'disabled'} onFocus={() => setUseLookup(true)} key={field.id} type="text" className="form-control my-2" />}

      <div className="form-card-footer d-flex justify-content-between">
        {
                    error
                    && <small className="error" dangerouslySetInnerHTML={{ __html: error }} />
                }

        {field.tooltip && <Tooltip tooltipText={field.tooltip} />}
      </div>
    </div>

  );
}

AddressSearchInput.defaultProps = {
  error: false,
};

export default AddressSearchInput;
